import { type UserPreferenceEntry, type UserPreferenceKey } from '@rentguru/commons-utils';
import { graphqlClient } from '@up2rent/graphql';

const USER_PREFERENCE_FIELDS = 'name value';

const USER_PREFERENCES_QUERY = `query AuthUserPreferences {
  authUserPreferences { ${USER_PREFERENCE_FIELDS} }
}`;

const SET_USER_PREFERENCE_MUTATION = `mutation SetAuthUserPreference($input: SetAuthUserPreferenceInput!) {
  setAuthUserPreference(input: $input) { ${USER_PREFERENCE_FIELDS} }
}`;

const RESET_USER_PREFERENCES_MUTATION = `mutation ResetAuthUserPreferences($input: ResetAuthUserPreferencesInput) {
  resetAuthUserPreferences(input: $input) { id status }
}`;

export const fetchUserPreferences = async (): Promise<UserPreferenceEntry[]> => {
  const data = await graphqlClient.request<{ authUserPreferences: UserPreferenceEntry[] }>(USER_PREFERENCES_QUERY);
  return data.authUserPreferences;
};

export const setUserPreferenceApi = async (name: UserPreferenceKey, value: string): Promise<UserPreferenceEntry> => {
  const data = await graphqlClient.request<{ setAuthUserPreference: UserPreferenceEntry }>(
    SET_USER_PREFERENCE_MUTATION,
    { input: { name, value } }
  );
  return data.setAuthUserPreference;
};

export const resetUserPreferencesApi = async (keys: UserPreferenceKey[]): Promise<void> => {
  await graphqlClient.request(RESET_USER_PREFERENCES_MUTATION, { input: { keys } });
};
